import typeToReducer from 'type-to-reducer'
import { AUTH_SUCCESS, AUTH_FAIL, AUTH_SIGNOUT, SET_AUTH_REDIRECT_PATH, STATUS_CHANGE_DIALOG_SUCCESS } from '../actions/actionTypes';


const initialState = {
    token: null,
    pk: null,
    showStatusChangeDialog: null,
    adminName: null,
    error: null,
    authRedirectPath: '/operation-room/map',
    doesRemember: null
};

const reducer = typeToReducer({
    [AUTH_SUCCESS]: (state, action) => ({
        ...state,
        token: action.payload.auth_token,
        adminName: action.payload.name,
        showStatusChangeDialog: action.payload.show_notification,
        pk: action.payload.pk,
        error: null
    }),
    [AUTH_FAIL]: (state, action) => ({
        ...state,
        error: action.error
    }),
    [AUTH_SIGNOUT]: (state, action) => ({
        ...state,
        token: null,
        showStatusChangeDialog: null,
        pk: null,
        adminName: null,
    }),
    [SET_AUTH_REDIRECT_PATH]: (state, action) => ({
        ...state,
        authRedirectPath: action.payload
    }),
    [STATUS_CHANGE_DIALOG_SUCCESS]: (state, action) => ({
        ...state,
        showStatusChangeDialog: false
    }),
    ['REMEMBER']: (state, action) => ({
        ...state,
        doesRemember: action.payload
    })
}, initialState);


export default reducer;


// WEBPACK FOOTER //
// ./src/store/reducers/auth.js